import Pqp from "../../3x1010/Pqp.js";
import Game from "../Game.js";
import Maze from "../maze/Maze.js";
import Lore from "../screen/fight/Lore.js";
import BasicAI from "../screen/mobs/ai/BasicAI.js";
import Bat from "../screen/mobs/Bat.js";
import Goblin from "../screen/mobs/Goblin.js";
import Orc from "../screen/mobs/Orc.js";
import Rat from "../screen/mobs/Rat.js";
import Slime from "../screen/mobs/Slime.js";
import Sniper from "../screen/mobs/Sniper.js";
import Spider from "../screen/mobs/Spider.js";
import Troll from "../screen/mobs/Troll.js";
import Screen from "../screen/Screen.js";
import Bout from "./Bout.js";

export default class DungeonMaster {
	constructor(cfg, mobcfg) {
		this.cfg = cfg;
		this.mobcfg = mobcfg;
		DungeonMaster.that = this;
	}

	createEnemiesForThisLevel(tileMap, sprites) {
		//console.log(tileMap.model.solution)
		let det = Game.that.featurer.getCurrentLevelDetails();
		let n = parseInt(det.monsters);
		let index = 0;
		let rules = det.rules;
		let toApplyRules = new Array();
		//n = 5;

		let rooms = Screen.that.model.rooms;
		let enemies = new Array();
		let ais = new Array();

		if (n === 0) {
			return [enemies, ais];
		}

		let sol = tileMap.model.solution.slice();
		sol.pop();
		let steps = Math.floor((sol.length) / n);
		let cellsSol = new Array();
		cellsSol.push(sol[Math.floor(sol.length / 2)]); // centro 
		let dec = 1;
		let inc = 1;
		let end = n;
		if (end > 3) {
			end = end / 2;
		}
		for (let x = 1; x < end; x++) {
			if (x % 2 === 0) {
				//dec
				cellsSol.push(sol[Math.floor(sol.length / 2) - steps * dec]); // prima
				dec++;
				//console.log("dec")
			} else {
				//inc
				cellsSol.push(sol[Math.floor(sol.length / 2) + steps * inc]); // dopo
				inc++;
				//console.log("inc")
			}

		}
		//console.log(sol);
		//console.log(cellsSol);
		// controllare se sono undefined
		let tmp = new Array();
		for (let x = 0; x < cellsSol.length; x++) {
			if (cellsSol[x]) {
				tmp.push(cellsSol[x]);
			}
		}
		cellsSol = tmp;
		Pqp.shuffle(cellsSol);


		for (let x = 0; x < n; x++) {
			if (rooms[x]) {
				let enAi = this.createEnemy(det, index, tileMap, sprites);
				let enemy = enAi[0];
				let ai = enAi[1];

				if (rules.indexOf("stack" + index + ":") < 0) {
					tileMap.addMob(enemy, Screen.that.model.rooms[x].getFreeCellNearCenterCell());
				} else {
					toApplyRules.push([index,enemy, Screen.that.model.rooms[x].getFreeCellNearCenterCell()]);
				}
				index++;

				enemies.push(enemy);
				ais.push(ai);
			} else {
				if (cellsSol[x]) {
					let enAi = this.createEnemy(det, index, tileMap, sprites);
					let enemy = enAi[0];
					let ai = enAi[1];
					if (rules.indexOf("stack" + index + ":") < 0) {
						tileMap.addMob(enemy, cellsSol[x]);
					} else {
						toApplyRules.push([index,enemy, cellsSol[x]]);
					}
					index++;
					enemies.push(enemy);
					ais.push(ai);
				}
			}
		}

		if (enemies.length < n) {

			let a = tileMap.model.deadEnds.slice();
			let tmp = new Array()
			for (let x = 0; x < a.length; x++) {
				if (!a[x].isChest()) {
					tmp.push(a[x]);
				}
			}
			a = tmp;

			a = Pqp.shuffle(a);
			let end = n - enemies.length;
			for (let x = 0; x < end; x++) {
				if (a[x]) {
					let enAi = this.createEnemy(det, index, tileMap, sprites);
					let enemy = enAi[0];
					let ai = enAi[1];

					if (rules.indexOf("stack" + index + ":") < 0) {
						tileMap.addMob(enemy, a[x]);
					} else {
						toApplyRules.push([index,enemy, a[x]]);
					}
					index++;


					enemies.push(enemy);
					ais.push(ai);
				}
			}
		}


		if (enemies.length < n) {

			let a = sol;
			for (let x = 0; x < 10; x++) {
				a.shift();
			}
			a = Pqp.shuffle(a);
			let end = n - enemies.length;
			for (let x = 0; x < end; x++) {
				let enAi = this.createEnemy(det, index, tileMap, sprites);
				let enemy = enAi[0];
				let ai = enAi[1];
				
				if (rules.indexOf("stack" + index + ":") < 0) {
					tileMap.addMob(enemy, a[x]);
				} else {
					toApplyRules.push([index,enemy, a[x]]);
				}
				index++;

				enemies.push(enemy);
				ais.push(ai);
			}


		}


		// Controlla eventuali regole
		//console.log(toApplyRules)
		for (let x = 0; x < toApplyRules.length; x++) {
			let index = toApplyRules[x][0];
			let enemy = toApplyRules[x][1];
			let rule = this.getRule(index);
			if (rule) {
				if (rule === "near_exit") {
					let cell = sol[sol.length - 1];
					tileMap.addMob(enemy, cell);
					// Aggiungere altre regole qui
				} else {
					// Posizione originale
					tileMap.addMob(enemy, toApplyRules[x][2]);
				}
			} else {
				// Posizione originale
				tileMap.addMob(enemy, toApplyRules[x][2]);
			}

		}

		//console.log(enemies,ais)
		return [enemies, ais];


	}

	getRule(index) {
		let det = Game.that.featurer.getCurrentLevelDetails();
		let rules = det.rules.split(",");
		for (let x = 0; x < rules.length; x++) {
			if (rules[x].indexOf("stack" + index + ":") >= 0) {
				return jQuery.trim(rules[x].split(":")[1]);
			}
		}
		return null;
	}

	createEnemy(det, n, tileMap, sprites) {
		let classes = this.clean(det.monstersType).split(",");

		let cls = classes[n];
		if (!cls) {
			cls = classes[Pqp.rnd(classes.length - 1)];
		}
		//console.log(cls)

		let enemy = this.createEnemyFromClass(sprites, cls, true)
		enemy.stackIndex = n;


		let ai = new BasicAI(Screen.that.model, tileMap);
		enemy.init();
		ai.attachTo(enemy);
		ai.init();
		return [enemy, ai];
	}

	createEnemyFromClass(sprites, cls, lInfoable) {
		let enemy
		if (cls === "rat") {
			enemy = new Rat(sprites, lInfoable);
		} else if (cls === "slime") {
			enemy = new Slime(sprites, lInfoable);
		} else if (cls === "bat") {
			enemy = new Bat(sprites, lInfoable);
		} else if (cls === "goblin") {
			enemy = new Goblin(sprites, lInfoable);
		} else if (cls === "sniper") {
			enemy = new Sniper(sprites, lInfoable);
		} else if (cls === "spider") {
			enemy = new Spider(sprites, lInfoable);
		} else if (cls === "orc") {
			enemy = new Orc(sprites, lInfoable);
		} else if (cls === "troll") {
			enemy = new Troll(sprites, lInfoable);
		}
		return enemy;
	}


	placeChests(model) {
		let det = Game.that.featurer.getCurrentLevelDetails();
		let n = parseInt(det.chests);
		let rooms = model.rooms;
		let a = model.torches.slice();
		Pqp.shuffle(a);
		Bout.incStatistic(Bout.STAT_CHESTS_TOTAL, n);;

		let toRem = new Array();
		for (let x = 0; x < n; x++) {
			if (rooms[x]) {
				let cell = rooms[x].getFreeCellUpperRow();
				if (cell) {
					if (!cell.booked) {
						cell.booked = true;
						model.statics.push({ type: Maze.STATIC_TYPE_CHEST, cell: cell })
					}
				}
			} else {
				//
				for (let x = 0; x < a.length; x++) {
					let s = model.getNearbyCell(a[x], Maze.DIR_S);
					let s1 = model.getNearbyCell(s, Maze.DIR_S);
					if (!s1.isWall()) {
						if (!s.booked) {
							s.booked = true;
							model.statics.push({ type: Maze.STATIC_TYPE_CHEST, cell: s })
							toRem.push(a[x]);
							a.splice(x, 1);
							break;
						}
					}
				}

			}
		}
		let tmp = new Array();
		//console.log(toRem)
		for (let y = 0; y < toRem.length; y++) {
			let cell = toRem[y]
			for (let x = 0; x < model.torches.length; x++) {
				//console.log(model.torches[x].id , cell.id)
				if (model.torches[x].id === cell.id) {
					tmp.push(x);
					break;
				}
			}
		}
		//console.log("---")
		//console.log(tmp);
		tmp.sort(function (a, b) {
			return b - a;
		});
		//console.log(tmp);
		for (let x = 0; x < tmp.length; x++) {
			model.torches.splice(tmp[x], 1);
		}

	}

	generateStackEnemies(mob) {
		if (mob.stack) {
			return mob.stack;
		}
		//console.log(mob.stackIndex)
		let det = Game.that.featurer.getCurrentLevelDetails();
		let stack = this.getStack(mob.race, this.clean(det.monstersStack), mob.stackIndex)
		//console.log(stack)

		let ret = [];

		// Pusha prima quello che si vede
		for (let x = 0; x < stack.length; x++) {
			let race = stack[x].split(" ")[0];
			ret.push(this.createEnemyFromClass(mob.sp, race, false));
		}


		for (let x = 0; x < ret.length; x++) {
			ret[x].init(this.sprites)
			Lore.add(ret[x], stack[x], this.mobcfg);
		}
		mob.stack = ret;

		return ret;

	}

	clean(s) {
		s = Pqp.safeReplace(s, "\n", "");
		s = Pqp.safeReplace(s, "\r", "");
		return s;
	}
	getStack(base, monsters, index) {
		let ret = [];
		let whichOnes = monsters.split(",")[index];
		let det = Game.that.featurer.getCurrentLevelDetails();

		if (whichOnes.indexOf("[") >= 0) {
			whichOnes = Pqp.safeReplace(whichOnes, "[", "");
			whichOnes = Pqp.safeReplace(whichOnes, "]", "");
			let races = whichOnes.split("|");
			for (let x = 0; x < races.length; x++) {
				let race = races[x];
				if (race.indexOf("?") >= 0) {
					let pref = ""
					if (race !== "?") {
						pref = race.substr(1);
					}
					let monsters = this.clean(det.monstersType).split(",");
					race = monsters[Pqp.rnd(monsters.length - 1)] + pref;
				}
				ret.push(race);
			}
		} else {
			for (let x = 0; x < parseInt(whichOnes); x++) {
				ret.push(base);
			}
		}

		return ret;
	}


}